
import CpuSetting from "../../../assets/duotone/CpuSetting.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CpuSettingIcon({ className, dataTestid = "CpuSettingIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CpuSetting data-testid={dataTestid} className={classes} {...rest} />
  );
}
